/**
 * Runtime null check, for when you need to convince Typescript.
 */
export function requireNonNull<T>(
  obj: T | null | undefined,
  message?: string,
): T {
  if (obj == null) throw new Error(message ?? `object is ${obj}`);
  return obj;
}
